// node_modules
import { FC, useEffect, useState } from "react";

type TCharacterButtonProps = {
    character: string,
    isActive: boolean,
    onClick: () => void
};

const defaultCharacter = "?";

export const CharacterButton: FC<TCharacterButtonProps> = ({character, isActive, onClick}: TCharacterButtonProps) => {
    // State
    const [currentCharacter, setCurrentCharacter] = useState<string>(defaultCharacter);

    // Logic
    useEffect(() => {
        if (!character || (character && character.trim().length < 1)) {
            setCurrentCharacter(defaultCharacter);
            return;
        }

        setCurrentCharacter(character.trim().toUpperCase().charAt(0));
    }, [character]);

    // Render
    return (
        <div style={{color: isActive ? "red" : "blue"}} onClick={onClick}>
            {currentCharacter}
        </div>
    );
};